// AI-CONTEXT: See docs/features/updates-log.md

import { useHistory, useParams } from 'react-router-dom'
import { client } from '../../hooks/Client'
import ScrollToTop from '../../hooks/ScrollToTop'
import useSettings from '../../hooks/Settings'
import activeUpdateModules from '../../helpers/updates/activeUpdateModules'
import formatUpdateDate from '../../helpers/updates/formatUpdateDate'
import { findFeaturedUpdate } from '../../helpers/updates/featuredUpdates'
import updates from '../../data/updates.json'

/**
 * De eigen pagina van één uitgelichte update: een schermafbeelding met daaronder
 * de uitleg in secties.
 *
 * Dezelfde poort als de lijst. Zonder die controle zou deze pagina een omweg om
 * de modulefilter heen zijn: wie het id kent, leest anders een verhaal over een
 * onderdeel dat zijn organisatie niet afneemt.
 *
 * Zolang de instellingen laden is niet bekend welke modules er afgenomen worden.
 * Er wordt dan niets getoond — ook geen 'niet gevonden', want die melding slaat
 * een tel later om en leest als een storing.
 * AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 */
const UpdateHighlight = () => {

  // Hooks
  ScrollToTop()
  const settings = useSettings()
  const history = useHistory()
  const { id } = useParams()

  const modules = settings.loaded ? activeUpdateModules(settings) : null
  const update = modules ? findFeaturedUpdate(updates, modules, id) : null

  const terug = () => history.push(`/${client}/updates`)

  // JSX
  return (
    <div className="main">
      <div className="main-container">
        <div className="update-highlight">

          <button type="button" className="update-highlight-back" onClick={terug}>
            ← Alle updates
          </button>

          {settings.loaded && !update &&
            <p className="update-highlight-missing">
              Deze update bestaat niet, of gaat over een onderdeel dat jouw organisatie niet gebruikt.
            </p>
          }

          {update && <>
            <div className="update-highlight-date">{formatUpdateDate(update.date)}</div>
            <h1>{update.title}</h1>
            <p className="update-highlight-lead">{update.highlight.lead}</p>

            <img
              className="update-highlight-image"
              src={`${process.env.PUBLIC_URL}/updates/${update.highlight.image}`}
              alt={update.highlight.imageAlt}
            />

            {update.highlight.sections.map((sectie) => (
              <section className="update-highlight-section" key={sectie.heading}>
                <h2>{sectie.heading}</h2>
                <p>{sectie.body}</p>
                {sectie.bullets &&
                  <ul>
                    {sectie.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
                  </ul>
                }
              </section>
            ))}
          </>}

        </div>
      </div>
    </div>
  )
}

export default UpdateHighlight
